import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/auth';

export default function RequirePro({ children, redirectTo = '/dashboard' }) {
  const { signed, user, load } = useContext(AuthContext);

  if (load) return null;
  if (!signed) return <Navigate to="/signin" replace />;
  if (user?.plano !== 'pro') return <Navigate to={redirectTo} replace />;

  return children;
}
